import{a as m}from"./chunk.F5ZXBOKG.js";import{a as h}from"./chunk.2AIXLGYE.js";import{a as i}from"./chunk.XPINZPW5.js";import{a as l}from"./chunk.65JZXZ5X.js";import{d as n}from"./chunk.DQ7YBHX4.js";import{c as e}from"./chunk.NWIV65VP.js";import{html as c}from"lit";import{property as o,state as d}from"lit/decorators.js";import{unsafeSVG as g}from"lit/directives/unsafe-svg.js";import{ifDefined as p}from"lit/directives/if-defined.js";import{css as f}from"lit";var u=f`
  ${h}

  :host {
    display: inline-block;
    font-size: max(1em, var(--he-icon-size));
    width: 1em;
    height: 1em;
    contain: strict;
    box-sizing: content-box !important;
    vertical-align: middle;
  }

  svg {
    display: block;
    height: 100%;
    width: 100%;
    fill: currentColor;
  }
`;var v=new DOMParser,t=class extends l{constructor(){super(...arguments);this.scope=n(this);this.svg=""}getUrl(){return this.name?this.scope.makePath(`icons/${this.name.toLowerCase()}.svg`):this.url?this.url:null}async setIcon(){let r=this.getUrl();if(r==null){this.svg&&(this.svg="");return}try{let s=await m(r);if(r!==this.getUrl())return;if(s.ok){let a=v.parseFromString(s.svg,"text/html").body.querySelector("svg");a?(this.svg=a.outerHTML,this.emit("he-load")):(this.svg="",this.emit("he-error",{detail:{status:s.status}}))}else this.svg="",this.emit("he-error",{detail:{status:s.status}})}catch(s){this.emit("he-error",{detail:{status:-1}})}}handleNameChange(){this.setIcon()}render(){return c`
      <span
        part="base"
        role=${p(this.label?"img":void 0)}
        aria-label=${p(this.label||void 0)}
        aria-hidden=${this.label?"false":"true"}
      >
        ${g(this.svg)}
      </span>
    `}};t.styles=u,t.baseName="icon",t.reactEvents={onHeLoad:new CustomEvent("he-load"),onHeError:new CustomEvent("he-error")},e([d()],t.prototype,"svg",2),e([o()],t.prototype,"name",2),e([o()],t.prototype,"label",2),e([o()],t.prototype,"url",2),e([i("name"),i("url")],t.prototype,"handleNameChange",1);var q=t;export{t as a,q as b};
